import * as React from "react";

import { BlocksResultProps } from "@grapesjs/react";
import { Box, Stack, Text } from "@mantine/core";

export type CustomBlockManagerProps = Pick<
  BlocksResultProps,
  "mapCategoryBlocks" | "dragStart" | "dragStop"
>;

export const CustomBlockManager = ({
  mapCategoryBlocks,
  dragStart,
  dragStop,
}: CustomBlockManagerProps) => {
  // console.log("CustomBlockManager", { mapCategoryBlocks });
  return (
    <Box className="gjs-custom-block-manager">
      <Stack>
        {Array.from(mapCategoryBlocks).map(([category, blocks]) => (
          <Stack key={category} spacing={"xs"}>
            <Text size={"md"} fw={500}>
              {category}
            </Text>
            <Stack spacing={8}>
              {blocks.map((block) => (
                <Box
                  key={block.getId()}
                  draggable
                  onDragStart={(ev) => dragStart(block, ev.nativeEvent)}
                  onDragEnd={() => dragStop(false)}
                  sx={{
                    border: "2px solid var(--mantine-color-gray-3)",
                    borderRadius: "6px",
                    backgroundColor: "var(--mantine-color-white)",
                    padding: "12px",
                  }}
                >
                  {/* <Box
                    h={40}
                    dangerouslySetInnerHTML={{ __html: block.getMedia()! }}
                    sx={{
                      svg: {
                        height: "100%",
                      },
                    }}
                  /> */}
                  <Box title={block.getLabel()}>{block.getLabel()}</Box>
                </Box>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
